import React from 'react'

const Features = ({singleHouse}) => {
  return (
    <div className="descriptions">
        <h1>Features</h1>
        {/* <div className="descr-details">
          <div className="left">
            <h3>Type :      </h3>
            <h3>Category :</h3>
            <h3>Price     : </h3>
            <h3>Location :</h3>
            <h3>Bedrooms :</h3>
            <h3>Bathroom : </h3>
            <h3>Amenitie : </h3>
            <h3>status   :</h3>
          </div>
          <div className="left">
            <h3>{singleHouse.type}</h3>
            <h3>{singleHouse.category} </h3>
            <h3>{singleHouse.price} </h3>
            <h3>{singleHouse.location}</h3>
            <h3>{singleHouse.bedrooms} </h3>
            <h3>{singleHouse.bathrooms} </h3>
            <h3>{singleHouse.amenities} </h3>
            <h3>{singleHouse.status} </h3>
          </div>
        </div> */}
        <h3>Not Available At The Moment</h3>
      </div>
  )
}

export default Features
